import React, { Component, useEffect, useState } from 'react'
import { useFormInput } from '../utils';
import { loadCategory, loadLanguage, loadLanguages, saveCategory, saveLanguage } from '../utils/Network';
import { useHistory } from 'react-router';
import { useParams } from "react-router-dom";


import SelectCategory from '../components/SelectCategory';
import SelectStatus from '../components/select/SelectStatus';
import SelectIsFeatured from 'cms/components/SelectIsFeatured';

export default function CategoryContent({ id }) {


    const history = useHistory();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(true);
    const [featured, setFeatured] = useState(false);
    const [parent, setParent] = useState(null)
    
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {


        if (id) {
            loadCategory(id).then(category => {
                setTitle(category.title)
                setDescription(category.description)
                setStatus(category.status)
                setFeatured(category.is_featured)
                setParent(category.parent)
            }).then(() => {

            });

        }
    }, [])

    const onChange = (e) => {

        switch (e.target.name) {
            case "title":
                    setTitle(e.target.value)
                break;
            case "description":
                setDescription(e.target.value)
                break;
            case "status":
                setStatus(e.target.value)
                break;
            case "category":
                setParent(e.target.value)
                break;
        
            default:
                break;
        }


    }
    const saveChanges = () => {
        setError(null);
        setLoading(true);
        saveCategory({id,title,description,status,featured,parent}).then(data=>{
            window.location.href="categories"
            setLoading(false)
        })
    }
    const handleValue = (value, name) => {
        switch (name) {
            case "category":
                setParent(value)
                break;
            case "status":
                setStatus(value)
                break;
            case "is_featured":
                    setFeatured(value)
                    break;
            default:
                break;
        }
    }

    return (
        <>
            <div className="col-md-4 users-filter-page-col cms-categories-shell">
                <div className="box cms-categories-form-box">
                    <div className="box-header with-border">
                        <h3 className="box-title">Add New </h3>
                    </div>
                    <div className="box-body padding-10">
                        <form >
                            <div className="form-group ">
                                <input type="text" name="title" className="form-control " value={title}  onChange={onChange} placeholder="Title" />
                            </div>
                            <div className="form-group mb-5">
                                <SelectCategory callback={handleValue} value={parent} />
                                <div className="clear"></div>
                            </div>
                            <div className="form-group mb-5">
                                <SelectStatus callback={handleValue} value={status} />
                                <div className="clear"></div>
                            </div>
                            <div className="form-group mb-5">
                                <SelectIsFeatured callback={handleValue} value={featured} />
                                <div className="clear"></div>
                            </div>
                        </form>
                        <div className="box-footer cms-categories-form-footer">
                            {id && (<>
                                <a href="categories" className="btn btn-cm">Cancel</a>
                            </>)}

                            <button type="button" onClick={saveChanges} disabled={loading} className="btn btn-cm pull-right">Save Changes</button>
                        </div>
                    </div>

                </div>
                {error && (
                    <>

                        <div className="alert alert-danger">
                            {error}
                        </div>
                    </>
                )}

                {loading && (
                    <>
                        <div className="alert alert-info">
                            please wait...
                        </div>
                    </>
                )}
            </div>


        </>


    )

}
